module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/role02-2a631b2c12182c7f9573f22f0570ed9b.png";